import { useEffect, useRef } from 'react';

export default function useScrollReveal(options = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -30px 0px' }
    );

    // Observe a single element (skip ones already revealed/being watched)
    const observeEl = (el) => {
      if (!el.classList.contains('visible')) observer.observe(el);
    };

    // Initial pass — elements present at mount
    container.querySelectorAll('.reveal').forEach(observeEl);

    // Watch for elements added later (e.g. category/filter changes that
    // re-render the list) so they get revealed too, not stuck at opacity:0
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // only element nodes
          if (node.classList && node.classList.contains('reveal')) {
            observeEl(node);
          }
          node.querySelectorAll?.('.reveal')?.forEach(observeEl);
        });
      });
    });
    mutationObserver.observe(container, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
  return ref;
}